module.exports = __webpack_public_path__ + "img/4.385d250b.png";